cv.PayErrorView = Marionette.LayoutView.extend({
  template: cv.Templates['pay/error/pay_error'],

  events: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.listenTo(vent, 'pay:prev_button', this.previous, this);

    console.log('PayErrorView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  previous: function(){
    vent.trigger('pay:prev_screen');
  },

  onShow: function(){
  }
});
